import React, { useEffect } from "react";
import { Col, Row, Card, Table, Alert } from "antd";
import Auxiliary from "util/Auxiliary";
import StudentProfileCard from "../../../components/Widgets/StudentProfileCard";
import { getStudentPracticeSessions, getStudentChapterProgress } from "../../../appRedux/sagas/Dashboard";
import { useDispatch, useSelector } from "react-redux";
import { practice_session_columns, challenge_session_columns, chapter_progress_columns } from "./data";
import DummyContentAlert from "../../../util/DummyContentAlert";
import _ from "lodash";


const StudentDetail = ({ match }) => {
  const { practice_sessions, challenge_sessions, teacher_details, chapter_progress } = useSelector(({ dashboard }) => dashboard);
  const student = practice_sessions ? practice_sessions.student : {}
  console.log(match)
  const { studentid } = match.params

  const getSubjectProgress = (progress, subject) => {
    let subjectresult = _.find(progress, { "name": subject });
    if (subjectresult)
      return _.map(subjectresult.chapters, (x)=>{return {...x, subjectname:subject}});
    return [];
  }

  const dispatch = useDispatch()
  useEffect(() => {
    getStudentPracticeSessions(studentid, dispatch)
    getStudentChapterProgress(studentid, dispatch)
  }, studentid)
  return (
    <Auxiliary>
      {/* <Row> */}
      <Col xl={24} lg={24} md={24} sm={24} xs={24}>
        <StudentProfileCard student={student} />
      </Col>
      {/* <Col xl={6} lg={12} md={12} sm={12} xs={24}>
          <Productivity/>
        </Col> */}
      {/* </Row> */}
      <Row>
        <DummyContentAlert subscribed={teacher_details ? teacher_details.subscribed : false} />
      </Row>
      <Row>
        <Col xl={6} lg={12} md={12} sm={12} xs={24}>
          <Card title="Maths">
            <Table showHeader={false} columns={chapter_progress_columns} dataSource={getSubjectProgress(chapter_progress, "maths")} pagination={false} size="small" ></Table>
          </Card>
        </Col>
        <Col xl={6} lg={12} md={12} sm={12} xs={24}>
          <Card title="Physics">
            <Table  showHeader={false}  columns={chapter_progress_columns} dataSource={getSubjectProgress(chapter_progress, "physics")} pagination={false} size="small"></Table>
          </Card>
        </Col>
        <Col xl={6} lg={12} md={12} sm={12} xs={24}>
          <Card title="Chemistry">
            <Table   showHeader={false} columns={chapter_progress_columns} dataSource={getSubjectProgress(chapter_progress, "chemistry")} pagination={false} size="small"></Table>
          </Card>
        </Col>
        <Col xl={6} lg={12} md={12} sm={12} xs={24}>
          <Card title="Biology">
            <Table  showHeader={false}  columns={chapter_progress_columns} dataSource={getSubjectProgress(chapter_progress, "biology")}  pagination={false} size="small"></Table>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col xl={12} lg={12} md={12} sm={24} xs={24}>
          <Card title="Practice List">
            <Table columns={practice_session_columns} dataSource={practice_sessions ? practice_sessions.sessions : []} pagination={true} scroll={{ y: 400 }} size="small" ></Table>
          </Card>
        </Col>
        <Col xl={12} lg={12} md={12} sm={24} xs={24}>
          <Card title="Challenge List">
            <Table columns={challenge_session_columns} dataSource={challenge_sessions ? challenge_sessions.sessions : []} pagination={true} scroll={{ y: 400 }} size="small"></Table>

          </Card>
        </Col>
      </Row>
    </Auxiliary>
  );
};

export default StudentDetail;
